import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppStateManageService } from './app-state-manage.service';

@Injectable({
  providedIn: 'root'
})
export class SubChapterStateManagement {
  public SubChapterRef: number = 0
  public SelectedSubChapterRef = signal<number>(this.SubChapterRef);
  public SelectedSubChapterName = signal<string>('');
  // NEW: Signal to hold the list of chapters (for dropdown)
  public SubChapterList = signal<{ ref: number, name: string }[]>([]);

  constructor(private appStateManagement: AppStateManageService) {
    // this.SubChapterRef = appStateManage.getTheme() == 'dark'? 'dark':'light' 

  }


  setSubChapterRefName(SubChapterRef: number, SubChapterName: string) {
    // Clear existing values first
    this.clearCurrentSubChapterRefName();

    this.SelectedSubChapterRef.set(SubChapterRef);
    this.SelectedSubChapterName.set(SubChapterName);
    this.appStateManagement.StorageKey.setItem('SelectedSubChapterRef', SubChapterRef.toString());
    this.appStateManagement.StorageKey.setItem('SelectedSubChapterName', SubChapterName);
  }

  setSubChapterRef(SubChapterRef: number) {
    // Clear existing values first
    // console.log('SubChapterRef', SubChapterRef);
    this.clearCurrentSubChapterRefName();
    // console.log('SubChapterRef', SubChapterRef);

    this.SelectedSubChapterRef.set(SubChapterRef);
    this.appStateManagement.StorageKey.setItem('SelectedSubChapterRef', SubChapterRef.toString());
  }

  getCurrentSubChapterRef(): number {
    return this.SelectedSubChapterRef();
  }

  getCurrentSubChapterName(): string {
    return this.SelectedSubChapterName(); // Returns the current signal value
  }

  getSubChapterList() {
    return this.SubChapterList;
  }

  clearCurrentSubChapterRefName = () => {
    this.SelectedSubChapterRef.set(this.SubChapterRef);
    this.SelectedSubChapterName.set('');
    this.appStateManagement.StorageKey.setItem('SelectedSubChapterRef', this.SubChapterRef.toString());
    this.appStateManagement.StorageKey.setItem('SelectedSubChapterName', '');
  }

}